/* eslint-disable import/prefer-default-export */
import styled from 'styled-components'

export const BottomNavigationWrapper = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #081339 !important;
  z-index: 100;
  height: 80px;
  width: 100%;
  display: grid;
  place-items: center;
  box-shadow: rgba(0, 0, 0, 0.09) 0px 3px 12px;
  color: #a2b4f2;

  .bottom-navigation-container {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
  }
  .tab-container {
    display: flex;
    justify-content: space-evenly;
    margin: auto;
    width: 100%;

    a:focus-visible .tab {
      outline: -webkit-focus-ring-color auto 1px;
    }
  }

  .tab .fas {
    font-size: 30px;
  }

  .tab {
    cursor: pointer;
    border-radius: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    width: 40px;
    padding: 8px;
    margin: 0 10px;
    font-weight: 600;
    font-size: 18px;
    background-color: #0a1a4c;
    color: #a2b4f2;
  }
  .tab:hover {
    background-color: #00000024;
  }
  .tab.active {
    color: #fff;
    background-color: #3e84ff !important;
  }
  .tab p {
    max-width: 0;
    overflow: hidden;
    font-size: 14px;
  }
  .tab.active p {
    margin-left: 10px;
    max-width: 200px;
    transition: 0.25s ease max-width;
  }

  .text {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 5px;
    font-family: 'Rubik';
    font-style: normal;
    font-weight: 400;
    font-size: 10px;
    line-height: 20px;
    color: rgba(162, 180, 242, 0.5);
  }
  .text.active {
    color: #fff;
  }
`
